import { UserId } from '@/portainer/users/types';
import { EffectiveAccessViewer } from '@/react/portainer/users/RolesView/AccessViewer/EffectiveAccessViewer';

export function AccessTab({ userId }: { userId: UserId }) {
  return (
    <EffectiveAccessViewer
      userId={userId}
      noWidget={false}
      emptyMessage="This user has no access to any environment."
      description="The role this user holds on each environment, and where it comes from."
    />
  );
}
